export default __webpack_public_path__ + "static/media/onboard.3e19a231.png";